import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import { Dialog, styled as muiStyled, Tab, Tabs, Typography } from "@mui/material";
import { SearchTextField } from "../common/TextField/searchTextField";
import useWindowDimensions from "@/lib/web-ui/useWindowDimensions";
import { purchasableSubjectsList } from "../../api/product";
import { KeywordChip } from "../Search/Chips";
import { ButtonWithIcon } from "../Search";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
export const SearchRecommendDialog = (param)=>{
    let { isOpen , onClose , modalValue , onClear , onChange , currentSubject , handleCurrentSubject , onSubmit , onClick , recommendSearchTermList  } = param;
    const { width , isTablet , isMobile  } = useWindowDimensions();
    const hasRecommendSearchTerm = useMemo(()=>recommendSearchTermList.terms && recommendSearchTermList.terms.length > 0, [
        recommendSearchTermList
    ]);
    return /*#__PURE__*/ _jsx(SearchDialog, {
        onClose: onClose,
        open: isOpen,
        children: /*#__PURE__*/ _jsxs(Panel, {
            children: [
                /*#__PURE__*/ _jsxs(SearchSection, {
                    children: [
                        isTablet && /*#__PURE__*/ _jsx(ButtonWithIcon, {
                            onClick: onClose
                        }),
                        /*#__PURE__*/ _jsx(SearchTextField, {
                            autoFocus: true,
                            onSearchClick: ()=>{
                                onSubmit();
                                mixpanelEvent("Icon UI Clicked", {
                                    "Icon Type": "Search",
                                    "Icon Position": "[Market] Search Modal"
                                });
                            },
                            onClear: onClear,
                            placeholder: recommendSearchTermList.placeHolder,
                            value: modalValue,
                            onChange: onChange,
                            onSubmit: (e)=>{
                                e.preventDefault();
                                onSubmit();
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(SubjectTabList, {
                    value: currentSubject,
                    onChange: (e, subject)=>{
                        handleCurrentSubject(subject);
                        mixpanelEvent("Tab UI Clicked", {
                            "Tab Type": "Search Modal",
                            "Tab Name": subject
                        });
                    },
                    centered: true,
                    children: purchasableSubjectsList().map((tab)=>/*#__PURE__*/ _jsx(SubjectTabItem, {
                            label: tab.label,
                            value: tab.key
                        }, tab.key))
                }),
                hasRecommendSearchTerm && /*#__PURE__*/ _jsxs(RecommendationKeywordSection, {
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "subtitle1",
                            component: "p",
                            sx: {
                                marginBottom: "12px"
                            },
                            children: "쏠북 인기 검색어"
                        }),
                        /*#__PURE__*/ _jsx(RecommendationKeywordList, {
                            children: recommendSearchTermList.terms.map((item, idx)=>{
                                return /*#__PURE__*/ _jsx(KeywordChip, {
                                    text: item,
                                    onClick: ()=>{
                                        mixpanelEvent("Search Keyword Clicked", {
                                            "Button Name": item,
                                            Subject: currentSubject,
                                            "Keyword Order": idx + 1,
                                            "Placeholder Text": recommendSearchTermList === null || recommendSearchTermList === void 0 ? void 0 : recommendSearchTermList.placeHolder
                                        });
                                        onClick(item);
                                    }
                                }, idx + "-" + item);
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const RecommendationKeywordList = muiStyled("ul")((param)=>{
    let { theme  } = param;
    return {
        display: "flex",
        flexWrap: "wrap",
        gap: "8px"
    };
});
const RecommendationKeywordSection = muiStyled("section")((param)=>{
    let { theme  } = param;
    return {
        padding: "24px 20px",
        maxWidth: "440px",
        margin: "0 auto",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        flex: "1 1 auto",
        height: "auto",
        overflowY: "auto",
        overscrollBehavior: "contain",
        [theme.breakpoints.down("lg")]: {
            maxWidth: "480px"
        }
    };
});
const SubjectTabList = muiStyled(Tabs)((param)=>{
    let { theme  } = param;
    return {
        width: "100%",
        margin: "0 auto",
        position: "relative",
        borderBottom: "1px solid ".concat(theme.palette.grey[50]),
        "& .MuiTabs-indicator": {
            backgroundColor: theme.palette.text["title"]
        },
        "& .MuiTabs-scroller": {
            maxWidth: "440px",
            margin: "0 auto",
            [theme.breakpoints.down("lg")]: {
                maxWidth: "480px"
            },
            [theme.breakpoints.down("sm")]: {
                maxWidth: "100%"
            }
        }
    };
});
const SubjectTabItem = muiStyled(Tab)((param)=>{
    let { theme  } = param;
    return {
        width: "100%",
        flex: 1,
        "&.MuiTab-root": {
            minWidth: "auto",
            color: theme.palette.text["disabled"],
            ...theme.typography.subtitle1,
            padding: "12px 0",
            "&:hover": {
                color: theme.palette.text["title"],
                transition: "color 0.3s"
            },
            "&.Mui-selected": {
                color: theme.palette.text["title"],
                "& ::selection": {
                    backgroundColor: theme.palette.text["title"]
                }
            }
        }
    };
});
const Panel = muiStyled("div")((param)=>{
    let { theme  } = param;
    return {
        display: "flex",
        flexDirection: "column",
        overflowY: "hidden",
        flex: "1 1 auto",
        width: "440px",
        [theme.breakpoints.down("lg")]: {
            width: "100%"
        }
    };
});
const SearchSection = muiStyled("div")((param)=>{
    let { theme  } = param;
    return {
        padding: "8px 20px",
        boxSizing: "border-box",
        [theme.breakpoints.down("lg")]: {
            display: "flex",
            padding: "8px 12px",
            gap: "4px",
            width: "100%",
            alignItems: "center",
            form: {
                width: "100%"
            }
        }
    };
});
const SearchDialog = muiStyled(Dialog)((param)=>{
    let { theme  } = param;
    return {
        overflowY: "scroll",
        "&.MuiBackdrop-root": {
            backgroundColor: "rgba(28, 31, 46, 0.2)"
        },
        "& .MuiDialog-container": {
            alignItems: "flex-start",
            "& .MuiDialog-paper": {
                margin: "4px 0 40px",
                borderRadius: "12px",
                boxShadow: "0px 4px 12px 0px rgba(0, 0, 0, 0.08), 0px 4px 8px 0px rgba(0, 0, 0, 0.04)",
                [theme.breakpoints.down("lg")]: {
                    width: "100%",
                    maxWidth: "100%",
                    borderRadius: "0",
                    margin: "0",
                    height: "100%",
                    maxHeight: "100%"
                }
            }
        }
    };
});
